import PackAssignDropdown from "./PackAssignDropdown";
import { HISTORY_FILTER_OPTIONS, writeHistoryFilter } from "../constants/levelHistory";

export default function HistoryFilterDropdown({ value, onChange }) {
  const handleChange = (nextValue) => {
    writeHistoryFilter(nextValue);
    onChange(nextValue);
  };

  return (
    <div className="level-history__filter-dropdown">
      <PackAssignDropdown
        options={HISTORY_FILTER_OPTIONS}
        value={value}
        onChange={handleChange}
        ariaLabel="Filtrer l'observateur d'évènements"
      />
    </div>
  );
}
